import { IVoluntario, IVoluntarioAction } from 'Types/Reducers/Voluntario';

const INITIAL_STATE: IVoluntario = {
  perfisVoluntariado: null,
	inscritoVoluntariado: false,
	urlVoluntariado: null,
};

function vereador(state = INITIAL_STATE, action: IVoluntarioAction) {
  switch (action.type) {
    case 'ALTERA_PERFIS_VOLUNTARIADO':
      return { ...state, perfisVoluntariado: action.perfisVoluntariado };

    case 'ALTERA_INSCRITO_VOLUNTARIADO':
      return { ...state, inscritoVoluntariado: action.inscritoVoluntariado };

    case 'ALTERA_URL_VOLUNTARIADO':
      return { ...state, urlVoluntariado: action.urlVoluntariado };

    case 'RESET_VOLUNTARIO':
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default vereador;